var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3cb5ea;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67 -446)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(67 446)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76 455)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,0A11,11,0,1,0,22,11,11.012,11.012,0,0,0,11,0Zm-.458,18.333a1.375,1.375,0,1,1,1.375-1.375A1.376,1.376,0,0,1,10.542,18.333Zm1.375-5.591v1.466a.458.458,0,0,1-.458.458H9.625a.458.458,0,0,1-.458-.458V11.917A1.836,1.836,0,0,1,11,10.083,1.833,1.833,0,1,0,9.167,8.25v.458a.458.458,0,0,1-.458.458H6.875a.458.458,0,0,1-.458-.458V8.25a4.583,4.583,0,1,1,5.5,4.492Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/FAQIcon.85d005de1bb3d5902f1e0e106e928555.svg";
export { ForwardRef as ReactComponent };